export default __webpack_public_path__ + "static/media/administative.abdd9c98.jpg";